// Emulates the TinyMCE 5 `fullpage` plugin, which was removed in TinyMCE 6 (and
// so never existed in its fork HugeRTE). The editor only ever edits the <body>
// of a document, but campaign
// HTML is frequently a *full* document whose doctype, <html> attributes and
// <head> (styles, meta tags) must survive a round-trip through the WYSIWYG
// editor. These pure functions split a full document into the shell surrounding
// the body and the body's inner HTML, and re-assemble it afterwards.
//
// Matching the old fullpage behavior, a bare fragment (no <body>) is wrapped into
// a full document on the way out, so switching to the WYSIWYG editor and back
// always yields a complete <html> document.

// Captures the <body ...> open tag and everything before it (group 1), the body's
// inner HTML (group 2), and the closing </body> plus everything after it (group
// 3). Case-insensitive; `[\s\S]` is used instead of the `s` flag for wider
// browser support.
const BODY_RE = /^([\s\S]*<body[^>]*>)([\s\S]*)(<\/body\s*>[\s\S]*)$/i;

// The shell used when the source content is a bare fragment. Mirrors the full
// document the fullpage plugin produced from fragment content.
function wrapFragment(body) {
  return `<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>\n${body}\n</body>\n</html>`;
}

// Splits `html` into the pieces the WYSIWYG editor needs. Returns a shell object
// carrying the surrounding markup (or a flag that the source was a fragment) plus
// the body inner HTML that should be loaded into the editor.
export function splitFullDocument(html) {
  const source = html == null ? "" : String(html);
  const match = source.match(BODY_RE);

  if (!match) {
    return { isFullDocument: false, prefix: "", suffix: "", body: source };
  }

  return {
    isFullDocument: true,
    prefix: match[1],
    suffix: match[3],
    body: match[2],
  };
}

// Re-assembles a full document from a shell (produced by splitFullDocument) and
// the (possibly edited) body inner HTML the editor returned.
export function wrapFullDocument(shell, body) {
  const inner = body == null ? "" : String(body);

  if (shell && shell.isFullDocument) {
    return shell.prefix + inner + shell.suffix;
  }

  return wrapFragment(inner);
}

export function fullDocumentBody(html) {
  return splitFullDocument(html).body;
}
